<!-- 任务5 -->
<template>
    <div>
      <div class="course_Task5">
        <el-row style="border: 1px solid #D3D3D3;margin: 0 20px 20px 20px;padding: 0 20px 20px 20px;min-height: calc(100vh - 280px);">
          <!-- <template v-if="examType == 2">
            <p style="background-color: rgb(239, 242, 247);margin: 0 -20px;color: #2789E2;padding: 20px;">
              任务得分：{{scoreInfo.score || 0}} 分
            </p>
          </template> -->
          <p class="fontB"><i class="el-icon-document-remove icon_"></i>任务名称：<span style="font-weight: 500;">{{taskInfo.taskTitle}}</span></p>
          <p class="fontB"><i class="el-icon-s-data icon_" style="color: #8a39c2;"></i>任务分值：
              <span style="font-weight: 500;">{{taskInfo.taskScore}} 分</span>
              <template v-if="examType == 2">
                <span style="color: red;margin-left: 100px;">任务得分：{{scoreInfo.score || 0}} 分</span>
              </template>
          </p>
          <p class="fontB"><i class="el-icon-document-copy icon_"></i>考核任务：</p>
          <el-row class="aljj">
            <previewIndex v-if="!$isEmpty(taskInfo.assessmentContent)" :modelValue="taskInfo.assessmentContent"></previewIndex>
          </el-row>
          <p class="fontB"><i class="el-icon-edit-outline icon_" style="color: #2eb68e;"></i>考核题目：</p>
          <el-row>
            <el-col :span="12">
              <el-table
                border
                ref="table"
                :data="tableData"
                style="width: calc(100% - 20px);">
                <template v-if='examType == 1 || examType == 3'>
                  <el-table-column prop="question" header-align="center" align="center" label="考核题目" width="120px">
                    <template slot-scope="scope">
                      <template v-if="examType != 3">
                        {{scope.row.question}}
                      </template>
                      <template v-if="examType == 3">
                        {{scope.row.handsOnSimulationTasksAssessmentQuestion}}
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="score" header-align="center" align="center" label="分值" width="120px">
                    <template slot-scope="scope">
                      <template v-if="examType != 3">
                        {{scope.row.score}}
                      </template>
                      <template v-if="examType == 3">
                        {{scope.row.handsOnSimulationTasksAssessmentScore}}
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="studentAnswer" header-align="center" align="center" label="我的答案">
                    <template slot-scope="scope">
                      <template v-if="examType == 3">
                        <el-input
                          type="textarea"
                          :autosize="{ minRows: 2, maxRows: 4}"
                          disabled
                          placeholder="请输入我的答案"
                          v-model="scope.row.handsOnSimulationTasksAssessmentAnswer">
                        </el-input>
                      </template>
                      <template v-if="examType != 3">
                        <el-input
                          type="textarea"
                          :autosize="{ minRows: 2, maxRows: 4}"
                          :disabled="examType == 2"
                          placeholder="请输入我的答案"
                          v-model="scope.row.studentAnswer">
                        </el-input>
                      </template>

                    </template>
                  </el-table-column>
                </template>
                <template v-if='examType == 2'>
                  <el-table-column prop="question" header-align="center" align="center" label="考核题目" width="120px"></el-table-column>
                  <el-table-column prop="rightAnswer" header-align="center" align="center" label="考核答案"></el-table-column>
                  <el-table-column prop="studentAnswer" header-align="center" align="center" label="我的作答"></el-table-column>
                  <el-table-column prop="score" header-align="center" align="center" label="标准分" width="120px"></el-table-column>
                  <el-table-column prop="studentScore" header-align="center" align="center" label="我的得分" width="120px"></el-table-column>
                </template>
              </el-table>
              <el-row class="tc m10" v-if="examType == 1">
                <el-button type="primary" @click="taskStepInfoEdit">提 交</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-row>
      </div>
    </div>
</template>
<script>
import previewIndex from "@/components/editorMd/previewIndex";	//富文本editorMd
export default {
  name: 'Task5',
  components: {
    previewIndex
  },
  props: {
    courseType: { //课程类型 1教师开课 2系统授权
      type: Number,
      default: function(){
        return 1;
      }
    },
    examType: { //考试类型 1：考试 2：查看成绩
      type: Number,
      default: function(){
        return 1;
      }
    },
    taskId: { //任务ID
      type: String,
      default: function(){
        return "";
      }
    },
    handsOnId: { //实训ID
      type: String,
      default: function(){
        return "";
      }
    },
    courseId : { //课程ID
      type: String,
      default: function(){
        return "";
      }
    },
    scoreInfo:{ //分值信息
      type:Object,
      default: function(){
        return {};
      }
    }
  },
  data() {
    return {
      tableData: [],
      answer:{},
      taskStepInfo:{},
      taskInfo:{} //任务详情
    }
  },
  created() {
    this.getInfo();
    if(this.examType != 3){
      this.getHandsOnTaskStepByTaskId();
    }
  },
  mounted() {

  },
  methods: {
    getInfo(){ //获取详情
      let url = "/api/teacherOpenCourseHandsOnSimulationTasks/getInfo.do";
      if(this.courseType == 2){
        url = "/api/handsOnSimulationTasks/getInfo.do";
      }
      this.$get(url,{taskId:this.taskId}).then((ret) =>{
        if(ret.code == 0){
          this.taskInfo = ret.data;
          if(this.examType == 3){
            this.tableData = ret.data.teacherOpenCourseHandsOnSimulationTasksAssessmentList;
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getHandsOnTaskStepByTaskId(){
      this.$get("/api/studentHandsOnTaskStep/getCourseCentreStepTask",{taskId:this.taskId,sourceType:this.examType,courseType:this.courseType}).then((ret) =>{
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data)){
            this.taskStepInfo = ret.data;
            this.tableData = ret.data.stems;
          }else{
            this.taskStepInfo = {};
            this.tableData = [];
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    taskStepInfoEdit(){
      this.taskStepInfo.stem = JSON.stringify(this.tableData);
      this.taskStepInfo.stems = null;
      this.taskStepInfo.courseType = this.courseType;
      this.$post("/api/studentHandsOnTaskStep/addHandsProcedure.do",this.taskStepInfo).then((ret) =>{
        if(ret.code == 0){
          this.$message.success("保存成功！");
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    }
  }
};
</script>
<style  lang="less">
  .course_Task5{
    .icon_{
      color: #2789E2;margin-right: 10px;
    }
    .has-gutter{
      th{
        border-color:#E5E5E5;
        background-color: #EFF2F7;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/lookCourse/components/PracticalTraining/Task4.vue